export function prop(propToFind: string, obj: any) {
  if (arguments.length === 1) return (_obj: any) => prop(propToFind, _obj);

  if (!obj) return undefined;

  return obj[propToFind];
}
